import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home.js";
import RolluPage from "./pages/Rollu.js";
import RasPage from "./pages/RunAStore.js";
import NoPage from "./pages/NoPage.js";
import TdPage from "./pages/TD.js";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route index element={<Home/>} />
          <Route path="/home" element={<Home/>}/>
          <Route path="/rollu" element={<RolluPage/>}/>
          <Route path="/runastore" element={<RasPage/>}/>
          <Route path="/towerdefense" element={<TdPage/>}/>
          <Route path="*" element={<NoPage />}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
